import { Cell, LevelPhase, LevelSim } from "@highmarch/domain";

/**
 * The rally flag as a button (QoL backlog C5): the rules the level's flag mode reads. The sim accepts the flag on any
 * cell a troop can stand on (TroopSystem.walkable); the button offers the road, where troops stand in the enemies'
 * way, so a tap snaps to the road cell nearest the finger rather than to a patch of grass beside it.
 */

/** The flag button's moment: a wave is running, the level is not over, and no card offer or tower sheet has the map. */
export function rallyUsable(sim: LevelSim, sheetOpen: boolean): boolean {
  return !sim.isOver && sim.phase === LevelPhase.WaveRunning && sim.currentOffer === null && !sheetOpen;
}

/** Where a tap with the flag armed can plant it: every road cell a troop can stand on (the fortress gate included). */
export function rallyCells(sim: LevelSim): Cell[] {
  return sim.road.roadCells.filter((c) => sim.troops.walkable(c));
}
